import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { OnboardingSupportOption } from '__generated__/globalTypes';
import { getCtaDestination } from './ctaDestinations';
import { OnboardingSupportOptions_onboardingSupportOptions_practicalSupport as PracticalSupportDetails } from './graphql/__generated__/OnboardingSupportOptions';

interface UseSupportOptionCtaArgs {
  /** Only practical support reads this. */
  practicalSupport?: PracticalSupportDetails | null;
  /** Called after navigating, so the caller can close and record. */
  onNavigate?(option: OnboardingSupportOption): void;
}

/**
 * Sends the member to an offering's destination. Client-side: a plain `<a href>`
 * reloads the app, and the design system `Button`'s `to` prop is deprecated.
 */
export const useSupportOptionCta = ({
  practicalSupport,
  onNavigate,
}: UseSupportOptionCtaArgs) => {
  const history = useHistory();

  return useCallback(
    (option: OnboardingSupportOption) => {
      const destination = getCtaDestination(option, practicalSupport);

      if (destination === undefined) {
        return;
      }

      history.push(destination);
      onNavigate?.(option);
    },
    [history, practicalSupport, onNavigate],
  );
};
